import { createApi } from '@reduxjs/toolkit/query/react';
import { createApiConfig } from '../../createApiConfig';

export const uMUserApi = createApi({
  reducerPath: 'uMUserApi',
  ...createApiConfig(process.env.REACT_APP_API_BASE_URL),
  endpoints: (builder) => ({
    login: builder.mutation({
      query: (data) => ({
        url: `users/login/`,
        method: 'POST',
        body: data,
      }),
    }),
    register: builder.mutation({
      query: (data) => ({
        url: `users/signup/`,
        method: 'POST',
        body: data,
      }),
    }),
    me: builder.query({
      query: () => `users/me/`,
    }),
    resetPassword: builder.mutation({
      query: (data) => ({
        url: `users/reset-password/`,
        method: 'POST',
        body: data,
      }),
    }),

    
  }),
});

export const {
  useLoginMutation,
  useRegisterMutation,
  useMeQuery,
  useResetPasswordMutation,
} = uMUserApi;
